import { render, staticRenderFns } from "./programPackPage.vue?vue&type=template&id=6ccf095c&scoped=true&"
import script from "./programPackPage.vue?vue&type=script&lang=ts&"
export * from "./programPackPage.vue?vue&type=script&lang=ts&"
import style0 from "./programPackPage.vue?vue&type=style&index=0&id=6ccf095c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccf095c",
  null
  
)

export default component.exports